module.exports = __webpack_public_path__ + "static/media/sample.03e2ae60.svg";